














































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import numeral from 'numeral';
import ShippingInfo from './components/ShippingInfo.vue';
import GoodsList from './components/GoodsList.vue';
import FreightFees from './components/FreightFees.vue';
import TaxFees from './components/TaxFees.vue';
import CostSummary from './components/CostSummary.vue';
import LinkedOrders from './components/LinkedOrders.vue';
import LinkedTTH from './components/LinkedTTH.vue';
import PaymentHistory from './components/PaymentHistory.vue';
import Documents from './components/Documents.vue';
import ComplaintList from './components/ComplaintList.vue';
import CustomerChat from './components/CustomerChat.vue';
import quotationServices from '@/services/quotation-services';

@Component({
    components: {
        Loading,
        ShippingInfo,
        GoodsList,
        FreightFees,
        TaxFees,
        CostSummary,
        LinkedOrders,
        'linked-tth': LinkedTTH,
        LinkedTTH,
        PaymentHistory,
        Documents,
        ComplaintList,
        CustomerChat,
    }
})
export default class DetailQuotation extends Vue {
    private isLoading: boolean = false;
    private quotation: any = {};
    private activeTab: string = 'shipping';

    private get quotationId(): number {
        return Number(this.$route.params.id) || 0;
    }

    private get displayTotalCost(): number {
        if (this.quotation.total_tax_and_fee_cost !== undefined && this.quotation.total_tax_and_fee_cost !== null) {
            return Number(this.quotation.total_tax_and_fee_cost) || 0;
        }
        return Number(this.quotation.total_cost) || 0;
    }

    private get displayBalanceDue(): number {
        if (this.quotation.can_thanh_toan !== undefined && this.quotation.can_thanh_toan !== null) {
            return Number(this.quotation.can_thanh_toan) || 0;
        }
        if (this.quotation.balance_due !== undefined && this.quotation.balance_due !== null) {
            return Number(this.quotation.balance_due) || 0;
        }
        return Math.max(0, this.displayTotalCost - (Number(this.quotation.total_paid) || 0));
    }

    private get canComplain(): boolean {
        const validStatuses = ['huy', 'draft'];
        return !!this.quotation && !validStatuses.includes(this.quotation.status);
    }

    private onComplaintsRefreshed(list: any[]) {
        this.$set(this.quotation, 'complaints', list);
    }

    @Watch('$route.query.tab')
    private onTabQueryChange(val: string) {
        if (val) {
            this.activeTab = val;
        }
    }

    private async created() {
        if (this.$route.query && this.$route.query.tab) {
            this.activeTab = String(this.$route.query.tab);
        }
        await this.loadDetail();
    }

    private async loadDetail() {
        if (!this.quotationId) return;
        this.isLoading = true;
        try {
            const res: any = await quotationServices.getById(this.quotationId);
            if (res && res.data && res.data.status === 200) {
                this.quotation = res.data.data || {};
                // Nếu báo giá đang ở trạng thái khiếu nại mà chưa có active_complain_id, tự động lấy khiếu nại hiện tại
                if (this.quotation.status === 'khieu-nai' && !this.quotation.active_complain_id) {
                    try {
                        const compRes: any = await quotationServices.getComplainByQuotationId(this.quotationId);
                        if (compRes && compRes.data && compRes.data.status === 200 && compRes.data.data) {
                            const cId = compRes.data.data.id || compRes.data.data.ID;
                            if (cId) {
                                this.$set(this.quotation, 'active_complain_id', cId);
                                this.$set(this.quotation, 'latest_complain_id', cId);
                            }
                        }
                    } catch (e) {
                        // silent
                    }
                }
            }
        } catch (e) {
            // silent
        } finally {
            this.isLoading = false;
        }
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }

    private getStatusBadgeClass(status: string): string {
        switch (status) {
            case 'draft':
                return 'label-default';
            case 'cho-duyet':
            case 'cho-bao-gia':
                return 'label-warning';
            case 'da-gui':
                return 'label-info';
            case 'kh-da-duyet':
            case 'xnk-da-duyet':
            case 'da-duyet':
                return 'label-primary';
            case 'dang-van-chuyen':
            case 'cho-xep-xe':
            case 'da-xep-xe':
            case 'dang-ve-kho-nhan':
            case 'da-nhap-kho-nhan':
                return 'label-info';
            case 'hoan-thanh':
                return 'label-success';
            case 'huy':
                return 'label-danger';
            default:
                return 'label-default';
        }
    }
}
